// Outside sports a lone booking-type tile ("Table Only", "Space Only", a
// clinic's "Session") is a choice with nothing to choose between. Sports,
// padel and schools keep their lone "Court Only" tile.
const HIDE_LONE_BOOKING_TYPE_FOR = new Set([
  'clinic',
  'member_club',
  'restaurant',
]);

/**
 * Whether the booking-type row should be hidden because it offers a single,
 * already-selected option. Shared by /book's row and card visibility.
 */
export function hidesLoneBookingType(
  businessType: string | null | undefined,
  bookingTypeCount: number,
): boolean {
  return (
    bookingTypeCount === 1 && HIDE_LONE_BOOKING_TYPE_FOR.has(businessType ?? '')
  );
}
